module.exports = __webpack_public_path__ + "img/page-title-heigh-emission.8617e684.svg";